// extracted by mini-css-extract-plugin
export default {"description":"Index_description__Mc-J1"};